import styled from 'styled-components';
import getColour from '@lendi-ui/commons/colours';
import { ml, mt } from '@lendi-ui/spacing';
import { link } from '@lendi-ui/typography';

export const StatusIconContainer = styled.div`
  ${ml('xxs')}
`;

export const LinkContainer = styled.div`
  text-align: center;
  ${mt('xxs')}
`;

export const Link = styled.a`
  ${link({ size: 'xs' })};
  color: ${() => getColour('interaction', 'main')};
  text-decoration: none;
  text-transform: uppercase;
`;
